export type AppEnvironment = 'development' | 'test' | 'stage';

export interface EnvironmentBanner {
  env: AppEnvironment;
  label: string;
  color: string; // MUI sx-compatible color string or hex
  textColor: string;
}

const BANNERS: Record<AppEnvironment, EnvironmentBanner> = {
  development: {
    env: 'development',
    label: 'DEVELOPMENT',
    color: '#2e7d32', // green[800]
    textColor: '#ffffff',
  },
  test: {
    env: 'test',
    label: 'TEST',
    color: '#e65100', // deepOrange[900]
    textColor: '#ffffff',
  },
  stage: {
    env: 'stage',
    label: 'STAGE',
    color: '#6a1b9a', // purple[800]
    textColor: '#ffffff',
  },
};

/**
 * Returns banner config for the current host, or null if no banner should be shown
 * (i.e. production or any unrecognised host).
 */
export function getEnvironmentBanner(): EnvironmentBanner | null {
  const { hostname } = window.location;

  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return BANNERS.development;
  }

  if (hostname.endsWith('.test.equipsoftware.app') || hostname === 'test.equipsoftware.app') {
    return BANNERS.test;
  }

  if (hostname.endsWith('.stage.equipsoftware.app') || hostname === 'stage.equipsoftware.app') {
    return BANNERS.stage;
  }

  return null;
}

/**
 * Returns the short (7-char) git commit SHA for display in the environment banner,
 * or null if no banner is shown (i.e. production) or the SHA is unavailable.
 */
export function getReleaseVersion(): string | null {
  if (getEnvironmentBanner() === null) return null;
  // __GIT_COMMIT__ is statically replaced by vite.config.ts define at startup.
  // The typeof guard prevents a ReferenceError if the dev server hasn't applied
  // the replacement yet (e.g. during Vite's initial module graph build).
  const sha = typeof __GIT_COMMIT__ !== 'undefined' ? __GIT_COMMIT__ : 'unknown';
  return sha && sha !== 'unknown' ? sha.slice(0, 7) : null;
}
